module.exports = __webpack_public_path__ + "img/badge_color_fia-foundation.e7cb67c2.svg";